import { GET, POST, PUT } from './api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from '../..';
import { selectMarketProps } from '../../selectors/market/market';

export interface CategoryRequestPayload {
  serviceRequestType: string;
  catalogueName: string;
  requestType: string;
  requestName: string;
  requestDescription: string;
  // relatedCategoryNames: string;
}

export interface UpdateRequestPayload {
  requestId: number;
  updatedData: {
    requestStatus: string;
    approverComments: string;
  };
}

export const getCategoryRequestTypes = createAsyncThunk(
  'marketServiceRequest/getCategoryRequestTypes',
  async (_, thunkAPI) => {
    const { dispatch } = thunkAPI;
    const result = await dispatch(
      GET({
        path: '/rrm-rc/category-request-types',
        label: 'Fetch category request types',
      }),
    );
    return result;
  },
  {
    condition: (_, { getState }) => {
      const { loading, requestTypes } = (getState() as RootState)
        .marketServiceRequest;
      return !loading && requestTypes.length === 0;
    },
  },
);

export const createCategoryRequest = createAsyncThunk(
  'marketServiceRequest/createCategoryRequest',
  async (data: CategoryRequestPayload, thunkAPI) => {
    const { dispatch, getState } = thunkAPI;
    const { retailUnit } = selectMarketProps(getState() as RootState);
    const result = await dispatch(
      POST({
        path: `/rrm-rc/${retailUnit}/service-request`,
        data,
        label: `Create Category Request in Retail Unit: ${retailUnit}`,
      }),
    );
    return result;
  },
);

export const getRequestList = createAsyncThunk(
  'marketServiceRequest/getRequestList',
  async ({ pageNo, pageSize }: { pageNo: number; pageSize: number }, thunkAPI) => {
    const { dispatch } = thunkAPI;
    const result = await dispatch(
      GET({
        path: `/rrm-rc/service-request?pageNo=${pageNo}&pageSize=${pageSize}`,
        label: 'Fetch service request list',
      }),
    );
    return result;
  },
  {
    condition: (_, { getState }) => {
      const { loading } = (getState() as RootState).marketServiceRequest;
      return !loading;
    },
  },
);

export const getMyRequestList = createAsyncThunk(
  'marketServiceRequest/getMyRequestList',
  async ({ pageNo, pageSize }: { pageNo: number; pageSize: number }, thunkAPI) => {
    const { dispatch } = thunkAPI;
    const result = await dispatch(
      GET({
        path: `/rrm-rc/service-request?pageNo=${pageNo}&pageSize=${pageSize}&myRequests=true`,
        label: 'Fetch my service request list',
      }),
    );
    return result;
  },
  {
    condition: (_, { getState }) => {
      const { loading } = (getState() as RootState).marketServiceRequest;
      return !loading;
    },
  },
);

export const updateRequestedItem = createAsyncThunk(
  'marketServiceRequest/updateRequestedItem',
  async ({ requestId, updatedData }: UpdateRequestPayload, thunkAPI) => {
    const { dispatch } = thunkAPI;

    const result = await dispatch(
      PUT({
        path: `/rrm-rc/service-request/${requestId}`,
        data: updatedData,
        label: `Update Category Request in Retail Unit: ${requestId}`,
      }),
    );
    return result;
  },
);

export const getHistory = createAsyncThunk(
  'marketServiceRequest/getHistory',
  async (
    { requestId, page = 0 }: { requestId: number; page?: number },
    thunkAPI,
  ) => {
    const { dispatch } = thunkAPI;
    const result = await dispatch(
      GET({
        path: `/rrm-rc/service-request/${requestId}/events?pageNo=${page}`,
        label: `Fetch History for Request ID: ${requestId}`,
      }),
    );
    return result;
  },
  {
    condition: (_, { getState }) => {
      const { loading } = (getState() as RootState).marketServiceRequest;
      return !loading;
    },
  },
);
